import { render } from "./userMedia.vue?vue&type=template&id=52a5a0e6&scoped=true"
import script from "./userMedia.vue?vue&type=script&lang=js"
export * from "./userMedia.vue?vue&type=script&lang=js"

import "./userMedia.vue?vue&type=style&index=0&id=52a5a0e6&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a5a0e6"]])

export default __exports__